const getMockInstance = () => ({
  init: () => {},
  logEvent: () => {},
  getUserId: () => null,
  setUserId: () => {},
  regenerateDeviceId: () => {},
  setUserProperties: () => {}
});

// As we upgrade to the new Amplitude Browser SDK,
// we can use this shim to adopt the new sdk, and keep the analytics functions unchanged for now.
const getAmplitudeBrowserSdkShim = () => {
  const instanceShim = {
    // ignore the callback since we don't use it anywhere, and isn't supported in the browser sdk.
    logEvent: (eventName: string, eventProperties: Record<string, unknown>, _?: () => void) => {
      window.amplitude.track(eventName, eventProperties);
    },
    regenerateDeviceId: window.amplitude.reset,
    setUserId: (userId: string | null) => {
      window.amplitude.setUserId(userId);
    }
  };

  return instanceShim;
};

const getAmplitudeInstance = () => {
  // "track" only exists in the new browser SDK. If it exists, return the browser sdk shim.
  if (window.amplitude && typeof window.amplitude.track === 'function') {
    return getAmplitudeBrowserSdkShim();
  }

  return getMockInstance();
};

export { getAmplitudeInstance };
